import styled, { css } from 'styled-components';
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import { space, color, layout, border, borderWidth, borderStyle } from 'styled-system';
import Text from '../../../atoms/Text';
const handleGridAlign = {
  left: css`
    grid-template-columns: auto repeat(1, auto) 1fr;
  `,
  right: css`
    grid-template-columns: 1fr repeat(1, auto) auto;
  `,
  default: css`
    grid-template-columns: 1fr repeat(1, auto) 1fr;
  `
};
export const Title = styled(Text)`
  align-self: center;
  font-weight: 500;
`;
export const LeftButton = styled.div`
  margin-right: auto;
`;
export const Container = styled.div`
  display: grid;
  ${props => handleGridAlign[props == null ? void 0 : props.align] || handleGridAlign.default}
  gap: 0 10px;
  padding: 20px 16px;
  border-bottom: 1px solid ${props => getBackgroundColor('darker')(props)};
  ${space}
  ${color}
  ${layout}
  ${border}
  ${borderWidth}
  ${borderStyle}
`;